import { useEffect } from 'react';

export function useTokenHandler() {
    // Store the token SYNCHRONOUSLY during render, before any child route mounts.
    // Child effects run before parent effects, so storing in this hook's own
    // effect created a race: a screen's first fetch (e.g. the aspsps list) ran
    // with no token in localStorage yet and failed. Idempotent, so re-renders
    // (and StrictMode double-render) are harmless; once the effect below cleans
    // the URL this becomes a no-op.
    const urlToken = new URLSearchParams(window.location.search).get('token');
    if (urlToken) {
        localStorage.setItem('appParams', JSON.stringify({ token: urlToken }));
    }

    useEffect(() => {
        // URL cleanup stays deferred to an effect: BankConnected captures its
        // handoff params from the URL at module load, and other consumers may
        // still read the query string during their mount.
        if (new URLSearchParams(window.location.search).get('token')) {
            const cleanUrl = window.location.pathname;
            window.history.replaceState({}, '', cleanUrl);
        }
    }, []); // Empty dependency array means this runs once on mount
}
